import { LOCAL_STORAGE_NAME } from 'js/constants/App';

import { createLogger } from 'redux-logger';
import thunkMiddleware from 'redux-thunk';
import { applyMiddleware, legacy_createStore } from 'redux';
import RootReducer from './RootReducer';
import reduxfreezeMiddleware from 'redux-freeze';
import { composeWithDevTools } from '@redux-devtools/extension';

// https://github.com/rt2zz/redux-persist
import { persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web

const ConfigureStore = () => {
  const middlewares = [thunkMiddleware];
  if (process.env.NODE_ENV !== 'production') {
    middlewares.push(
      createLogger({
        collapsed: true,
        duration: true,
        timestamp: true,
      })
    );
  }
  if (JW_WATCH) {
    middlewares.unshift(reduxfreezeMiddleware);
  }

  const persistConfig = {
    key: LOCAL_STORAGE_NAME,
    storage,
    whitelist: [], // whitelist of store keys to persist in localstorage
  };

  const persistedReducer = persistReducer(persistConfig, RootReducer);

  const store = legacy_createStore(persistedReducer, composeWithDevTools(applyMiddleware(...middlewares)));

  return store;
};

export default ConfigureStore();
